import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand-column">
            <Link to="/" className="footer-brand">
              <span className="footer-brand-mark" aria-hidden="true">I</span>
              <span className="footer-brand-name">Indian Food Delight</span>
            </Link>
            <p className="footer-tagline">
              A thoughtful collection of Indian recipes, made for the joy of your everyday table.
            </p>
          </div>
          <div className="footer-explore">
            <p className="footer-kicker">EXPLORE</p>
            <nav className="footer-links" aria-label="Footer navigation">
              <Link className="footer-link" to="/recipes">Recipes</Link>
              <Link className="footer-link" to="/dish">Find a dish</Link>
              <Link className="footer-link" to="/ingredients">Cook with ingredients</Link>
              <Link className="footer-link" to="/diet">Meal plans</Link>
            </nav>
          </div>
        </div>

        <hr className="footer-divider" />

        <div className="footer-bottom">
          <span className="footer-copy">
            &copy; {new Date().getFullYear()} Indian Food Delight. All rights reserved.
          </span>
          <span className="footer-copy footer-signoff">Rooted in tradition <span aria-hidden="true">✦</span></span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
